export default function ValidationAlert({ message }) {
  if (!message) return null;
  return <div className="rounded-xl border border-brand-dangerBorder bg-brand-dangerBg px-3 py-2 text-sm text-brand-dangerText">{message}</div>;
}
